module.exports = __webpack_public_path__ + "static/media/180324_DSC08147_532.00d32746.jpg";